import { render } from "./ContentComponent.vue?vue&type=template&id=0f147eaf&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import "./ContentComponent.vue?vue&type=style&index=0&id=0f147eaf&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f147eaf"]])

export default __exports__